import Chart from 'chart.js';
import 'whatwg-fetch';
import 'url-polyfill';
// import 'url-search-params-polyfill';
import * as helpers from '../helpers';

function getChartData(element) {
    const chartDataContainer = element.querySelector('[data-chart-data]');
    const chartData = {};

    if (chartDataContainer === null) {
        return;
    }

    const chartDataItems = [...chartDataContainer.querySelectorAll('.chart-data__item')];

    // Create empty arrays for data;
    const chartDataLabels = [];
    const chartDataBackgrounds = [];
    const chartDataValues = [];

    chartDataItems.forEach((chartItem) => {
        const colorboxStyles = getComputedStyle(chartItem.querySelector('.chart-data__colorbox'));
        chartDataBackgrounds.push(colorboxStyles.backgroundColor);
        chartDataLabels.push(chartItem.textContent);
        chartDataValues.push(Number(chartItem.dataset.value));
    });

    // Set options for object
    chartData.labels = chartDataLabels;
    chartData.backgroundColors = chartDataBackgrounds;
    chartData.values = chartDataValues;

    // return chartDataObject
    return chartData;
}

function setChartFormHandler(id, chart) {
    const form = document.querySelector(`[data-chart-form-id="${id}"]`);
    const results = document.querySelector(`[data-chart-id="${id}"]`);
    let resultsContainer = null;

    if (form === null) {
        return;
    }

    if (results) {
        resultsContainer = helpers.findAncestor(results, 'interests-block__results');
    }

    form.addEventListener('submit', (e) => {
        const { url } = form.dataset;

        if (!url) {
            return;
        }

        e.preventDefault();

        const formQuery = helpers.serializeForm(form);

        fetch(`${url}?${formQuery}`, {
            method: 'GET',
            // credentials: 'include',
        })
            .then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }

                const error = new Error(response.statusText);
                error.response = response;
                throw error;
            })
            .then(response => response.text())
            .then((data) => {
                if (resultsContainer) {
                    const chartDataContainer = resultsContainer.querySelector('.interests-results__chart-data');

                    if (helpers.hasClass(resultsContainer, '-is-hidden')) {
                        helpers.removeClass(resultsContainer, '-is-hidden');

                        const formContainer = helpers.findAncestor(form, 'interests-block__vote');
                        if (formContainer) {
                            helpers.addClass(formContainer, '-is-hidden');
                        }
                    }

                    chartDataContainer.innerHTML = data;

                    const chartData = getChartData(resultsContainer);
                    chart.data = {
                        labels: chartData.labels,
                        datasets:
                            [{
                                data: chartData.values,
                                backgroundColor: chartData.backgroundColors,
                                borderWidth: 0,
                            }],
                    };
                    chart.update();
                }
            });
    });
}

export default function drawChart(chartSelector) {
    const chartElements = [...document.querySelectorAll(chartSelector)];

    chartElements.forEach((chartElement) => {
        const chartId = chartElement.dataset.chartId;
        const cnvs = chartElement.querySelector('canvas');

        if (cnvs) {
            const ctx = cnvs.getContext('2d');
            const chartData = getChartData(chartElement);
            const chart = new Chart(ctx, {
                // The type of chart we want to create
                type: 'doughnut',
                // The data for our dataset
                data: {
                    labels: chartData.labels,
                    datasets: [{
                        data: chartData.values,
                        backgroundColor: chartData.backgroundColors,
                        borderWidth: 0,
                    }],
                },
                // Configuration options go here
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: false,
                    cutoutPercentage: 65,
                    tooltips: {
                        // Disable the on-canvas tooltip
                        enabled: false,
                        custom(tooltipModel) {
                            // Tooltip Element
                            let tooltipEl = document.getElementById('js-chart-tooltip');

                            // Create element on first render
                            if (!tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'js-chart-tooltip';
                                document.body.appendChild(tooltipEl);
                            }

                            // Hide if no tooltip
                            if (tooltipModel.opacity === 0) {
                                tooltipEl.style.opacity = '0';
                                return;
                            }

                            // Set caret Position
                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }

                            function getBody(bodyItem) {
                                return bodyItem.lines;
                            }

                            // Set Text
                            if (tooltipModel.body) {
                                const bodyLines = tooltipModel.body.map(getBody);
                                let innerHtml = '';
                                bodyLines.forEach((body, i) => {
                                    const colors = tooltipModel.labelColors[i];
                                    innerHtml += `<span class="chart-tooltip"><span style="background-color: ${colors.backgroundColor}"></span>${body}</span>`;
                                });
                                if (tooltipEl) {
                                    tooltipEl.innerHTML = innerHtml;
                                }
                            }

                            const position = chart.canvas.getBoundingClientRect();

                            // Display, position, and set styles for font
                            tooltipEl.style.opacity = '1';
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.left = `${position.left + window.pageXOffset + tooltipModel.caretX}px`;
                            tooltipEl.style.top = `${position.top + window.pageYOffset + tooltipModel.caretY}px`;
                            tooltipEl.style.pointerEvents = 'none';
                            tooltipEl.style.zIndex = '100';
                            tooltipEl.style.transition = '500ms';
                        },
                    },
                },
            });

            if (chartId) {
                setChartFormHandler(chartId, chart);
            }
        }
    });
}
